import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "projects" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "table"
}
const _hoisted_7 = { style: {"text-align":"left"} }
const _hoisted_8 = { class: "nomer" }
const _hoisted_9 = { style: {"color":"black"} }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "work" }
const _hoisted_12 = { class: "type" }
const _hoisted_13 = { class: "link" }
const _hoisted_14 = {
  key: 0,
  class: "link2"
}
const _hoisted_15 = ["href", "title"]
const _hoisted_16 = ["href", "title"]
const _hoisted_17 = ["href", "title"]
const _hoisted_18 = {
  key: 1,
  class: "link2"
}
const _hoisted_19 = ["href", "title"]
const _hoisted_20 = ["href", "title"]
const _hoisted_21 = {
  key: 2,
  class: "link2"
}
const _hoisted_22 = ["href", "title"]
const _hoisted_23 = ["href", "title"]
const _hoisted_24 = { key: 3 }
const _hoisted_25 = ["href", "title"]
const _hoisted_26 = { class: "description" }
const _hoisted_27 = { class: "grade" }
const _hoisted_28 = {
  key: 3,
  class: "container"
}
const _hoisted_29 = { class: "block" }
const _hoisted_30 = { style: {"color":"black"} }
const _hoisted_31 = { class: "working-date" }
const _hoisted_32 = {
  key: 0,
  class: "tire"
}
const _hoisted_33 = { class: "description" }
const _hoisted_34 = { class: "link" }
const _hoisted_35 = {
  key: 0,
  class: "link2"
}
const _hoisted_36 = ["href", "title"]
const _hoisted_37 = ["href", "title"]
const _hoisted_38 = ["href", "title"]
const _hoisted_39 = {
  key: 1,
  class: "link2"
}
const _hoisted_40 = ["href", "title"]
const _hoisted_41 = ["href", "title"]
const _hoisted_42 = {
  key: 2,
  class: "link2"
}
const _hoisted_43 = ["href", "title"]
const _hoisted_44 = ["href", "title"]
const _hoisted_45 = { key: 3 }
const _hoisted_46 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectsSearch = _resolveComponent("ProjectsSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('projects.title')) + " ", 1),
      _createElementVNode("i", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeView && _ctx.changeView(...args))),
        title: _ctx.tableView ? _ctx.$t('extra.listView') : _ctx.$t('extra.tableView')
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['fa', _ctx.tableView ? 'fa-list' : 'fa-th'])
        }, null, 2)
      ], 8, _hoisted_2),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createElementVNode("i", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleOrder && _ctx.toggleOrder(...args))),
        title: _ctx.reverseOrder ? _ctx.$t('extra.ascOrder') : _ctx.$t('extra.desOrder')
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['fas', _ctx.reverseOrder ? 'fa-arrow-alt-circle-up' : 'fa-arrow-alt-circle-down'])
        }, null, 2)
      ], 8, _hoisted_3),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createElementVNode("i", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pSearch && _ctx.pSearch(...args))),
        class: "search",
        title: _ctx.projectSearch ? _ctx.$t('extra.closeSearch') : _ctx.$t('extra.openSearch')
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['fas', _ctx.projectSearch ? 'fa-binoculars' : 'fa-search'])
        }, null, 2)
      ], 8, _hoisted_4)
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("line", null, null, -1)),
    (_ctx.projectSearch)
      ? (_openBlock(), _createBlock(_component_ProjectsSearch, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.projectSearch)
      ? (_openBlock(), _createElementBlock("line", _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.tableView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("th", null, "№", -1)),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('projects.name')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('projects.description')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('projects.technologies')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedProjects, (prj) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: prj.id
                }, [
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(prj.id), 1)
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("div", null, _toDisplayString(this.$i18n.locale === "uk" ? prj.title_ua : this.$i18n.locale === "es" ? prj.title_es : prj.title_en), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(this.$i18n.locale === "uk" ? prj.start_date_ua : this.$i18n.locale === "es" ? prj.start_date_es : prj.start_date_en), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "tire" }, "–", -1)),
                      _createElementVNode("span", null, _toDisplayString(this.$i18n.locale === "uk" ? prj.end_date_ua : this.$i18n.locale === "es" ? prj.end_date_es : prj.end_date_en), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(this.$i18n.locale === "uk" ? prj.type_ua : this.$i18n.locale === "es" ? prj.type_es : prj.type_en), 1),
                    _createElementVNode("div", _hoisted_13, [
                      (prj.demolink && prj.youtubelink)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("a", {
                              href: prj.demolink,
                              class: "demolink",
                              title: _ctx.$t('projects.titleLink'),
                              target: "_blank"
                            }, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.link')), 1)
                            ], 8, _hoisted_15),
                            _createElementVNode("a", {
                              href: prj.sourcelink,
                              class: "github",
                              title: _ctx.$t('projects.titleGithub'),
                              target: "_blank"
                            }, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.github')), 1)
                            ], 8, _hoisted_16),
                            _createElementVNode("a", {
                              href: prj.youtubelink,
                              class: "youtube",
                              title: _ctx.$t('projects.titleYoutube'),
                              target: "_blank"
                            }, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.youtube')), 1)
                            ], 8, _hoisted_17)
                          ]))
                        : (prj.demolink && prj.sourcelink)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("a", {
                                href: prj.demolink,
                                class: "demolink",
                                title: _ctx.$t('projects.titleLink'),
                                target: "_blank"
                              }, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.link')), 1)
                              ], 8, _hoisted_19),
                              _createElementVNode("a", {
                                href: prj.sourcelink,
                                class: "github",
                                title: _ctx.$t('projects.titleGithub'),
                                target: "_blank"
                              }, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.github')), 1)
                              ], 8, _hoisted_20)
                            ]))
                          : (prj.sourcelink && prj.youtubelink)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("a", {
                                  href: prj.sourcelink,
                                  class: "github",
                                  title: _ctx.$t('projects.titleGithub'),
                                  target: "_blank"
                                }, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.github')), 1)
                                ], 8, _hoisted_22),
                                _createElementVNode("a", {
                                  href: prj.youtubelink,
                                  class: "youtube",
                                  title: _ctx.$t('projects.titleYoutube'),
                                  target: "_blank"
                                }, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.youtube')), 1)
                                ], 8, _hoisted_23)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("a", {
                                  href: prj.sourcelink,
                                  class: "github",
                                  title: _ctx.$t('projects.titleGithub'),
                                  target: "_blank"
                                }, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.github')), 1)
                                ], 8, _hoisted_25)
                              ]))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(this.$i18n.locale === "uk" ? prj.description_ua : this.$i18n.locale === "es" ? prj.description_es : prj.description_en), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(prj.techno), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedProjects, (prj) => {
            return (_openBlock(), _createElementBlock("div", {
              key: prj.id,
              class: "prj"
            }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("h3", null, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(prj.id) + ". ", 1),
                  _createTextVNode(_toDisplayString(this.$i18n.locale === "uk" ? prj.title_ua : this.$i18n.locale === "es" ? prj.title_es : prj.title_en), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", null, _toDisplayString(this.$i18n.locale === "uk" ? prj.start_date_ua : this.$i18n.locale === "es" ? prj.start_date_es : prj.start_date_en), 1),
                  (prj.end_date_en)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "–"))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(this.$i18n.locale === "uk" ? prj.end_date_ua : this.$i18n.locale === "es" ? prj.end_date_es : prj.end_date_en), 1)
                ]),
                _createElementVNode("div", _hoisted_33, _toDisplayString(this.$i18n.locale === "uk" ? prj.description_ua : this.$i18n.locale === "es" ? prj.description_es : prj.description_en), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('projects.type')) + ": ", 1),
                  _createTextVNode(_toDisplayString(this.$i18n.locale === "uk" ? prj.type_ua : this.$i18n.locale === "es" ? prj.type_es : prj.type_en), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('projects.technologies')) + ": ", 1),
                  _createTextVNode(_toDisplayString(prj.techno), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  (prj.demolink && prj.youtubelink)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("a", {
                          href: prj.demolink,
                          class: "demolink",
                          title: _ctx.$t('projects.titleLink'),
                          target: "_blank"
                        }, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.link')), 1)
                        ], 8, _hoisted_36),
                        _createElementVNode("a", {
                          href: prj.sourcelink,
                          class: "github",
                          title: _ctx.$t('projects.titleGithub'),
                          target: "_blank"
                        }, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.github')), 1)
                        ], 8, _hoisted_37),
                        _createElementVNode("a", {
                          href: prj.youtubelink,
                          class: "youtube",
                          title: _ctx.$t('projects.titleYoutube'),
                          target: "_blank"
                        }, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.youtube')), 1)
                        ], 8, _hoisted_38)
                      ]))
                    : (prj.demolink && prj.sourcelink)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("a", {
                            href: prj.demolink,
                            class: "demolink",
                            title: _ctx.$t('projects.titleLink'),
                            target: "_blank"
                          }, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.link')), 1)
                          ], 8, _hoisted_40),
                          _createElementVNode("a", {
                            href: prj.sourcelink,
                            class: "github",
                            title: _ctx.$t('projects.titleGithub'),
                            target: "_blank"
                          }, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.github')), 1)
                          ], 8, _hoisted_41)
                        ]))
                      : (prj.sourcelink && prj.youtubelink)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("a", {
                              href: prj.sourcelink,
                              class: "github",
                              title: _ctx.$t('projects.titleGithub'),
                              target: "_blank"
                            }, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.github')), 1)
                            ], 8, _hoisted_43),
                            _createElementVNode("a", {
                              href: prj.youtubelink,
                              class: "youtube",
                              title: _ctx.$t('projects.titleYoutube'),
                              target: "_blank"
                            }, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.youtube')), 1)
                            ], 8, _hoisted_44)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("a", {
                              href: prj.sourcelink,
                              class: "github",
                              title: _ctx.$t('projects.titleGithub'),
                              target: "_blank"
                            }, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t('projects.github')), 1)
                            ], 8, _hoisted_46)
                          ]))
                ])
              ])
            ]))
          }), 128))
        ]))
  ]))
}